import React from 'react';
import { Link } from 'react-router-dom';
import { MINGU_ENABLED } from '../config/features';
import { EnrolledSubject } from './types';

const SubjectFirstRun: React.FC<{ subject: EnrolledSubject }> = ({ subject }) => (
  <div className="space-y-6" data-testid="subject-first-run">
    <div className="rounded-lg p-6 text-white shadow" style={{ backgroundColor: subject.colour }}>
      <h2 className="text-2xl font-bold">Welcome to {subject.name}</h2>
      <p className="mt-2 text-white/90">
        Take a short diagnostic so we can start you at the right unit.
      </p>
      <Link
        to={`/subjects/${subject.id}/lesson?mode=diagnostic`}
        className="mt-4 inline-block rounded-lg bg-white px-4 py-2 font-semibold"
        style={{ color: subject.colour }}
      >
        Start the diagnostic
      </Link>
    </div>

    {MINGU_ENABLED && (
      <Link
        to="/mingu"
        className="block rounded-lg border-2 border-dashed p-4 text-sm font-medium text-gray-800 dark:text-gray-100"
        style={{ borderColor: subject.colour }}
      >
        Ask me what's different from Methods
      </Link>
    )}

    <div className="rounded-lg bg-white p-6 shadow dark:bg-gray-800">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white">Your units</h3>
        {subject.placeholder && (
          <span className="rounded-full bg-yellow-100 px-2 py-1 text-xs font-medium text-yellow-800">
            Placeholder content
          </span>
        )}
      </div>
      <ol className="space-y-3 opacity-50" aria-label="Unit preview">
        {subject.units.map((unit, index) => (
          <li key={unit.title} className="rounded-lg border border-gray-200 p-4 dark:border-gray-700">
            <p className="font-medium text-gray-900 dark:text-white">
              Unit {index + 1}. {unit.title}
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">{unit.topics.join(' · ')}</p>
          </li>
        ))}
      </ol>
    </div>
  </div>
);

export default SubjectFirstRun;
